/**
 * @typedef {Object} Variant
 * @property {string} body - The body type of the variant.
 * @property {string} engine-volume - Engines of the variant, separated by " / ".
 * @property {string} socket - The socket type of the variant (e.g. "PC07-FT").
 */

/**
 * @typedef {Object} Model
 * @property {string} model - The name of the model.
 * @property {Array<Variant>} variants - The variants of the model.
 */

/**
 * @typedef {Object} MakeModel
 * @property {string} make - The make of the vehicle.
 * @property {Array<Model>} models - The models of the make.
 */

/**
 * @typedef {Array<MakeModel>} MakeModelArray - assets/alladmindata.json (same for every market).
 */

document.addEventListener("DOMContentLoaded", async function () {
  // TABS START
  const tabChangeEvent = new Event("tabChange");
  const tabsState = {
    activeTabId: document.querySelector(".tab-trigger.active")
      ? document.querySelector(".tab-trigger.active").dataset.tabId
      : null,
  };
  const tabsContainer = document.querySelector(".tabs-container");
  const tabsTriggers = document.querySelectorAll(".tab-trigger");

  tabsContainer.addEventListener("tabChange", function (e) {
    const tabId = tabsState.activeTabId;
    const activeTabTrigger = document.querySelector(".tab-trigger.active");
    const activeTabContent = document.querySelector(".tab-content.active");

    const targetTabTrigger = document.querySelector(
      `.tab-trigger[data-tab-id="${tabId}"]`
    );
    const targetTabContent = document.querySelector(
      `.tab-content[data-tab-id="${tabId}"]`
    );

    activeTabTrigger?.classList.remove("active");
    activeTabContent?.classList.remove("active");

    targetTabTrigger.classList.add("active");
    targetTabContent.classList.add("active");
  });

  tabsTriggers.forEach((tabTrigger) => {
    tabTrigger.addEventListener("click", function () {
      tabsState.activeTabId = tabTrigger.dataset.tabId;
      tabsContainer.dispatchEvent(tabChangeEvent);
    });
  });
  // TABS END

  // DROPDOWN & SEARCH START
  let breadcrumbContainer = document.querySelector(".breadcrumb-dd-inst-container")
  let breadcrumbBrand = document.querySelector(".breadcrumb-dd-inst-container .breadcrumb-brand");
  let breadcrumbModel = document.querySelector(".breadcrumb-dd-inst-container .breadcrumb-model");
  let breadcrumbYear = document.querySelector(".breadcrumb-dd-inst-container .breadcrumb-year");
  let breadcrumbEngine = document.querySelector(".breadcrumb-dd-inst-container .breadcrumb-engine");


  const dropdownState = {
    selectedMake: null,
    selectedModel: null,
    selecedYear: null,
    selectedEngine: null,
    pcCode: null,
    enginesToDisplay: [],
    maxHeight: 320,
  };
  const dropdownContainer = document.querySelector(
    ".vehicle-select-dropdown-container"
  );
  const dropdownHandle = document.querySelector(
    ".vehicle-select-dropdown-handle"
  );
  const optionsContainer = dropdownContainer.querySelector(
    ".vehicle-select-dropdown-container .options-container"
  );
  const options = dropdownContainer.querySelector(
    ".vehicle-select-dropdown-container .options"
  );
  const resetHandle = document.querySelector(".dropdown-buttons .reset-handle");
  const videoContainer = document.querySelector(
    ".installation-video-container"
  );
  const iframeContainer = videoContainer.querySelector(".iframe-wrapper");
  const videoIframe = videoContainer.querySelector("iframe");
  const optionsSearch = document.querySelector(
    ".vehicle-select-dropdown-container .options-search"
  );
  const socketMismatchTextElement = document.querySelector(
    ".socket-mismatch-information-text"
  );
  const socketMismatchText = socketMismatchTextElement.dataset.preceder;

  const fitmentsUrl = dropdownContainer.dataset.fitmentsUrl;
  const installationVideosUrl = dropdownContainer.dataset.installationsVideos;
  const installationVideoTitle = document.querySelector(
    ".installation-video-container .installation-video-title"
  );
  const invalidPcError = document.querySelector(".invalid-pc-error");
  const defaultInstallationVideoTitle = installationVideoTitle.textContent;
  const installationVideoSelection = document.querySelector(
    ".installation-video-selection"
  );
  const pcCodesDataList = document.querySelector("datalist#pc-codes");
  const pcNumberInput = document.querySelector(
    ".pc-code-input-container .pc-code-input"
  );
  const iconContainer = document.querySelector(
    ".pc-code-input-container .icon-container"
  );

  // Shared loader from pc-fitments.js (sorted makes / models, fetched once per page)
  function getMakeModels() {
    if (window.PCFitments) return window.PCFitments.load(fitmentsUrl);
    return fetch(fitmentsUrl).then((response) => response.json());
  }

  /**
   * @type {MakeModelArray}
   */
  const makeModels = await getMakeModels();
  const installationVideos = await fetch(installationVideosUrl).then(
    (response) => response.json()
  );

  Object.keys(installationVideos).forEach((pcCode) => {
    const option = document.createElement("option");
    option.value = pcCode;
    pcCodesDataList.appendChild(option);
  });

  optionsSearch.addEventListener("input", function () {
    const searchValue = optionsSearch.value.toLowerCase();
    const items = options.children;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const text = item.textContent.toLowerCase();
      if (text.includes(searchValue)) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    }
    setDropdownHeight();
  });

  function resetSearch() {
    optionsSearch.value = "";
  }

  iconContainer.addEventListener("click", handlePcSearchInputSubmit);
  pcNumberInput.addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      handlePcSearchInputSubmit();
    }
  });
  function handlePcSearchInputSubmit() {
    resetDropdown({ preventHideInstallationVideo: true });
    const pcCode = pcNumberInput.value.toUpperCase();
    const videoInfo = installationVideos[pcCode];
    if (!videoInfo) {
      invalidPcError.classList.remove("hidden");
      installationVideoTitle.classList.add("hidden");
      videoIframe.removeAttribute("src");
      iframeContainer.style.display = "none";
      return;
    }
    iframeContainer.style.display = "block";
    invalidPcError.classList.add("hidden");
    installationVideoTitle.classList.remove("hidden");
    installationVideoTitle.textContent = defaultInstallationVideoTitle.replace(
      "##PC##",
      pcCode
    );
    const src = videoInfo.video;
    videoIframe.src = src;
    const sharedSockets = videoInfo.info;
    if (sharedSockets) {
      const [firstSocket, ...restSockets] = sharedSockets
        .split("-")
        .map((item) => item.trim());
      if (pcCode !== firstSocket) {
        socketMismatchTextElement.textContent = `${socketMismatchText} ${sharedSockets}`;
      }
    }
  }

  dropdownHandle.addEventListener("click", function () {
    if (dropdownContainer.classList.contains("opened")) {
      closeDropdown();
    } else {
      openDropdown();
    }
  });

  function appendBrands() {
    options.innerHTML = "";
    makeModels.forEach((make) => {
      const brand = document.createElement("li");
      brand.classList.add("brand");
      brand.textContent = make.make;
      options.appendChild(brand);
      brand.addEventListener("click", function () {
        breadcrumbContainer.style.display = "flex";
        breadcrumbBrand.style.display = "flex";
        breadcrumbBrand.innerHTML = make.make;

        dropdownState.selectedMake = make.make;
        appendModels(make.make);
        showResetButton();
        resetSearch();
      });
    });
    if (dropdownContainer.classList.contains("opened")) {
      setDropdownHeight();
    }
  }

  function appendModels(make) {
    const models = makeModels.find((item) => item.make === make).models;
    options.innerHTML = "";
    models.forEach((model) => {
      const modelItem = document.createElement("li");
      modelItem.classList.add("model");
      modelItem.textContent = model.model;
      modelItem.addEventListener("click", function () {
        breadcrumbModel.innerHTML = model.model;
        breadcrumbModel.style.display = "flex";

        dropdownState.selectedModel = model.model;
        appendYears(model);
        resetSearch();
      });
      options.appendChild(modelItem);
      setDropdownHeight();
    });
  }

  // One row per body / year; a body can come with several variants (sockets)
  function appendYears(model) {
    options.innerHTML = "";
    const bodies = new Map();
    model.variants.forEach((variant) => {
      // Engines are listed with " / " or "-" ("1.0L TSI-1.4L TSI"); a dash inside a name ("T-Jet") is kept
      const engines = (variant["engine-volume"] || "")
        .replace(/^\(|\)$/g, "")
        .split(/\s*\/\s*|\s*-\s*(?=\d)|-\s+/)
        .map((item) => item.trim())
        .filter(Boolean);
      if (!bodies.has(variant.body)) bodies.set(variant.body, []);
      const list = bodies.get(variant.body);
      (engines.length ? engines : [""]).forEach((engine) => {
        if (!list.some((item) => item.engine === engine && item.socket === variant.socket)) {
          list.push({ engine, socket: variant.socket });
        }
      });
    });
    [...bodies.keys()].reverse().forEach((year) => {
      const yearItem = document.createElement("li");
      yearItem.classList.add("year");
      yearItem.textContent = year;
      options.appendChild(yearItem);
      setDropdownHeight();
      yearItem.addEventListener("click", function () {
        breadcrumbYear.innerHTML = year;
        breadcrumbYear.style.display = "flex";

        dropdownState.selecedYear = year;
        dropdownState.enginesToDisplay = bodies.get(year);
        showEngines();
        resetSearch();
      });
    });
  }

  function showEngines() {
    options.innerHTML = "";
    dropdownState.enginesToDisplay.forEach(({ engine, socket }) => {
      const engineItem = document.createElement("li");
      engineItem.classList.add("engine");
      engineItem.textContent = engine || socket;
      engineItem.addEventListener("click", function () {
        breadcrumbEngine.innerHTML = engineItem.textContent;
        breadcrumbEngine.style.display = "flex";

        dropdownState.pcCode = socket;
        handleEngineClick(engine);
      });

      options.appendChild(engineItem);
    });
    setDropdownHeight();
  }
  function handleEngineClick(engine) {
    dropdownState.selectedEngine = engine;
    const pcCodeMatch = extractPcCode(dropdownState.pcCode);
    if (pcCodeMatch) {
      resetSearch();
      const videoInfo = installationVideos[pcCodeMatch];
      if (!videoInfo) {
        invalidPcError.classList.remove("hidden");
        installationVideoTitle.classList.add("hidden");
        videoIframe.removeAttribute("src");
        iframeContainer.style.display = "none";
        return;
      }
      iframeContainer.style.display = "block";
      invalidPcError.classList.add("hidden");
      installationVideoTitle.classList.remove("hidden");
      installationVideoTitle.textContent =
        defaultInstallationVideoTitle.replace("##PC##", pcCodeMatch);
      const src = videoInfo.video;
      const sharedSockets = videoInfo.info;
      if (sharedSockets) {
        const [firstSocket, ...restSockets] = sharedSockets
          .split("-")
          .map((item) => item.trim());
        if (pcCodeMatch !== firstSocket) {
          socketMismatchTextElement.textContent = `${socketMismatchText} ${sharedSockets}`;
        }
      }
      videoIframe.src = src;

      const initalSelectionPreceder =
        installationVideoSelection.dataset.defaultPreceder;

      const selectionParts = [
        dropdownState.selectedMake,
        dropdownState.selectedModel,
        dropdownState.selecedYear,
        dropdownState.selectedEngine,
      ].filter(Boolean);
      const selection = `<span style="color: #fc3; font-weight: 500;">${initalSelectionPreceder}</span> ${selectionParts.join(" / ")}`;
      installationVideoSelection.innerHTML = selection;      

      /* BreadCrumb */
      breadcrumbContainer.style.display = "none"
      breadcrumbBrand.style.display = "none";
      breadcrumbModel.style.display = "none";
      breadcrumbYear.style.display = "none";
      breadcrumbEngine.style.display = "none";

      breadcrumbBrand.innerHTML = "";
      breadcrumbModel.innerHTML = "";
      breadcrumbYear.innerHTML = "";
      breadcrumbEngine.innerHTML = "";
    }
  }

  videoIframe.addEventListener("load", function () {
    if (videoIframe.src !== "") {
      videoContainer.classList.add("visible");
      closeDropdown();
    }
  });

  function openDropdown() {
    dropdownContainer.classList.add("opened");
    setDropdownHeight();
  }
  function closeDropdown() {
    optionsContainer.style.maxHeight = "0px";
    setTimeout(() => {
      dropdownContainer.classList.remove("opened");
    }, 200);
  }

  function showResetButton() {
    resetHandle.classList.add("visible");
  }
  function hideResetButton() {
    resetHandle.classList.remove("visible");
  }
  resetHandle.addEventListener("click", function () {
    resetDropdown();
  });

  function resetDropdown(payload) {
    dropdownState.selectedMake = null;
    dropdownState.selectedModel = null;
    dropdownState.selecedYear = null;
    dropdownState.selectedEngine = null;
    dropdownState.pcCode = null;
    dropdownState.enginesToDisplay = [];
    resetSearch();
    if (!payload?.preventHideInstallationVideo) hideInstallationVideo();
    appendBrands();
    hideResetButton();
    installationVideoSelection.textContent = "";
    socketMismatchTextElement.textContent = "";

    /* BreadCrumb */
      breadcrumbContainer.style.display = "none"
      breadcrumbBrand.style.display = "none";
      breadcrumbModel.style.display = "none";
      breadcrumbYear.style.display = "none";
      breadcrumbEngine.style.display = "none";

      breadcrumbBrand.innerHTML = "";
      breadcrumbModel.innerHTML = "";
      breadcrumbYear.innerHTML = "";
      breadcrumbEngine.innerHTML = "";
  }

  function hideInstallationVideo() {
    videoContainer.classList.remove("visible");
    setTimeout(() => {
      videoIframe.removeAttribute("src");
      iframeContainer.style.display = "none";
    }, 200);
  }

  function setDropdownHeight() {
    const currentOptions = dropdownContainer.querySelector(
      ".vehicle-select-dropdown-container .options"
    );
    const childrenArr = Array.from(currentOptions.children).filter(
      (item) => item.style.display !== "none"
    );
    const currentItemCount = childrenArr.length;
    const { height } = childrenArr[0].getBoundingClientRect();
    const optionsStyles = window.getComputedStyle(currentOptions);
    const optionsContainerStyles = window.getComputedStyle(optionsContainer);
    const optionStyles = window.getComputedStyle(currentOptions.children[0]);

    const optionsPadding =
      parseFloat(optionsStyles.paddingTop) +
      parseFloat(optionsStyles.paddingBottom);
    const optionsMargin =
      parseFloat(optionsStyles.marginTop) +
      parseFloat(optionsStyles.marginBottom);
    const optionsContainerPadding =
      parseFloat(optionsContainerStyles.paddingTop) +
      parseFloat(optionsContainerStyles.paddingBottom);
    const optionMargin =
      parseFloat(optionStyles.marginTop) +
      parseFloat(optionStyles.marginBottom);

    const searchHeight = optionsSearch.getBoundingClientRect().height;
    const searchStyles = window.getComputedStyle(optionsSearch);

    const searchMargin =
      parseFloat(searchStyles.marginTop) +
      parseFloat(searchStyles.marginBottom);
    const totalSearchHeight = searchHeight + searchMargin;

    const dropdownHeight =
      height * currentItemCount +
      optionsPadding +
      optionsMargin +
      optionsContainerPadding +
      optionMargin +
      totalSearchHeight;

    optionsContainer.style.maxHeight = `${Math.min(
      dropdownHeight,
      dropdownState.maxHeight
    )}px`;
  }

  function extractPcCode(string) {
    const pcCodeMatch = string.match(/PC\d+/);
    if (!pcCodeMatch) {
      return;
    }
    return pcCodeMatch[0];
  }
  (function initDropdown() {
    appendBrands();
  })();
  // DROPDOWN & SEARCH END

  // ACCORDION START
  const accordionItems = document.querySelectorAll(".accordion-item");

  accordionItems.forEach((accordionItem) => {
    const accordionTitle = accordionItem.querySelector(".accordion-title");
    const accordionContent = accordionItem.querySelector(".accordion-content");
    accordionTitle.addEventListener("click", function () {
      const isOpened = accordionItem.dataset.opened === "true";
      const openedItem = document.querySelector(
        ".accordion-item[data-opened='true']"
      );
      if (openedItem && openedItem !== accordionItem) {
        openedItem.querySelector(".accordion-content").style.maxHeight = "0px";
        setTimeout(() => {
          openedItem.dataset.opened = "false";
        }, 200);
      }
      if (!isOpened) {
        accordionContent.style.maxHeight = `${accordionContent.scrollHeight}px`;
        setTimeout(() => {
          accordionItem.dataset.opened = "true";
          const rect = accordionTitle.getBoundingClientRect();
          const isOutOfView = rect.top < 0 || rect.bottom > window.innerHeight;
          if (isOutOfView) {
            accordionTitle.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }, 200);
      } else {
        accordionContent.style.maxHeight = "0px";
        setTimeout(() => {
          accordionItem.dataset.opened = "false";
        }, 200);
      }
    });
  });
  // ACCORDION END
});
